import React, { useState } from "react";
import PartnerFinanceTable from "./PartnerFinanceTable";
import PartnerVehiclesTable from "./PartnerVehiclesTable";

type PartnerVehicleAndFinanceProps = {
  partnerId: string;
};

const PartnerVehicleAndFinance: React.FC<PartnerVehicleAndFinanceProps> = ({
  partnerId,
}) => {
  const [activeTab, setActiveTab] = useState("vehicles");

  const TabContent = () => {
    if (activeTab === "vehicles") {
      return <PartnerVehiclesTable partnerId={partnerId} />;
    } else if (activeTab === "finance") {
      return <PartnerFinanceTable />;
    }
    return null;
  };
  return (
    <div>
      <div className="">
        <div className="bg-white rounded-[10px] p-2 mt-5 h-[70px] flex items-center overflow-x-auto">
          <nav className="flex px-2 whitespace-nowrap min-w-max">
            <button
              onClick={() => setActiveTab("vehicles")}
              className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                activeTab === "vehicles"
                  ? "bg-primary/20 text-primary rounded-[8px]"
                  : "border-transparent text-pColor hover:text-hColor"
              }`}
            >
              Vehicles
            </button>
            <button
              onClick={() => setActiveTab("finance")}
              className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                activeTab === "finance"
                  ? "bg-primary/20 text-primary rounded-[8px]"
                  : "border-transparent text-pColor hover:text-hColor"
              }`}
            >
              Finance
            </button>
          </nav>
        </div>
        {/* Tab Content */}
        <div className="mt-5">
          <TabContent />
        </div>
      </div>
    </div>
  );
};

export default PartnerVehicleAndFinance;
